var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEncrypted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92251 0.8V6.66667H15.5328V0.8H5.92251ZM16.3328 6.66667V0.7C16.3328 0.3134 16.0194 0 15.6328 0H5.82251C5.43591 0 5.12251 0.313401 5.12251 0.7V6.66667H0.7C0.313401 6.66667 0 6.98007 0 7.36667V20.1C0 20.4866 0.313399 20.8 0.699999 20.8H20.7553C21.1419 20.8 21.4553 20.4866 21.4553 20.1V7.36667C21.4553 6.98007 21.1419 6.66667 20.7553 6.66667H16.3328ZM0.8 7.46667V20H20.6553V7.46667H0.8Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47103 11.8705C9.12408 12.3332 8.89766 12.9906 8.89766 13.7337C8.89766 14.4769 9.12408 15.1343 9.47103 15.5969C9.8179 16.0594 10.2665 16.3081 10.7284 16.3081C11.1903 16.3081 11.639 16.0594 11.9858 15.5969C12.3328 15.1343 12.5592 14.4769 12.5592 13.7337C12.5592 12.9906 12.3328 12.3332 11.9858 11.8705C11.639 11.4081 11.1903 11.1594 10.7284 11.1594C10.2665 11.1594 9.8179 11.4081 9.47103 11.8705ZM8.83103 11.3905C9.29155 10.7765 9.95828 10.3594 10.7284 10.3594C11.4986 10.3594 12.1653 10.7765 12.6258 11.3905C13.0862 12.0044 13.3592 12.8342 13.3592 13.7337C13.3592 14.6333 13.0862 15.463 12.6258 16.0769C12.1653 16.6909 11.4986 17.1081 10.7284 17.1081C9.95828 17.1081 9.29155 16.6909 8.83103 16.0769C8.37061 15.463 8.09766 14.6333 8.09766 13.7337C8.09766 12.8342 8.37061 12.0044 8.83103 11.3905Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncrypted);
export default __webpack_public_path__ + "static/media/encrypted.4f837bcb.svg";
export { ForwardRef as ReactComponent };